import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SocialAuthStateService {

  private _user?: {
    name: string;
    email: string;
    provider?: string;
    provider_id?: string;
    provider_token?: string;
    provider_refresh_token?: string;
    provider_expires_in?: number;
    provider_avatar?: string;
  };

  setUser(user: any) {
    this._user = user;
  }

  getUser() {
    return this._user;
  }

  clear() {
    this._user = undefined;
  }
}
